// Helpers para extraer videoId de URLs de YouTube + construir URLs de
// embed y thumbnail. Compartido entre VideoOnlyView (embed) y
// BibliotecaEjercicios/PrescribirRutina (thumbnail).
//
// Sprint 3 PR4 — extraído de VideoOnlyView.tsx donde vivía privado.

/** Extrae el video ID de una URL de YouTube. Soporta formatos:
 *    https://www.youtube.com/watch?v=ID
 *    https://youtu.be/ID
 *    https://youtube.com/embed/ID
 *    https://www.youtube-nocookie.com/embed/ID
 *  Devuelve undefined si la URL no es parseable o el ID es muy corto
 *  (heurística mínima: 5 caracteres). */
export function extractYoutubeVideoId(
  url: string | undefined,
): string | undefined {
  if (!url) return undefined;
  let videoId: string | undefined;
  try {
    const u = new URL(url);
    if (u.hostname.includes("youtu.be")) {
      videoId = u.pathname.slice(1);
    } else if (u.pathname.startsWith("/embed/")) {
      videoId = u.pathname.replace("/embed/", "");
    } else {
      videoId = u.searchParams.get("v") ?? undefined;
    }
  } catch {
    return undefined;
  }
  if (!videoId || videoId.length < 5) return undefined;
  return videoId;
}

/** URL de embed privacy-enhanced (youtube-nocookie). Sin autoplay.
 *  Devuelve undefined si la URL original no es parseable. */
export function getYoutubeEmbedUrl(
  url: string | undefined,
): string | undefined {
  const videoId = extractYoutubeVideoId(url);
  if (!videoId) return undefined;
  return `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}`;
}

/** URL de thumbnail estática (hqdefault.jpg, 480x360). NO embed —
 *  solo una img tag liviana. Devuelve undefined si la URL original
 *  no es parseable. */
export function getYoutubeThumbnailUrl(
  url: string | undefined,
): string | undefined {
  const videoId = extractYoutubeVideoId(url);
  if (!videoId) return undefined;
  return `https://img.youtube.com/vi/${encodeURIComponent(videoId)}/hqdefault.jpg`;
}
